import { theme } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { useContext } from 'react';
import * as EntityHeaders from './entityHeaders';
import DashboardTabs from './DashboardTabs';
import UiContext from '../../lib/UiContext';
const InfoPanel = ({
  setIsOpen
}) => {
  const style = {
    paddingBottom: 0,
    backgroundColor: theme.useToken().token.colorBgContainer
  };
  const uiContext = useContext(UiContext);
  if (!uiContext.entity) {
    return null;
  }
  const HeaderComponent = uiContext.entity.type === 'STUDENT' ? EntityHeaders.Student : EntityHeaders[uiContext.entity.__typename];
  return <HeaderComponent ChildComponent={({
    menu,
    breadcrumbs = [],
    title,
    extra
  }) => <PageHeader breadcrumb={{
    separator: '/',
    items: breadcrumbs.map((e, i) => ({
      title: i,
      label: e
    })),
    itemRender: ({
      label
    }) => <span className="pageheader-crumb" children={label} />
  }} ghost={false} title={title} subTitle={<a onClick={() => setIsOpen(true)} children="Change" />} footer={<DashboardTabs menuData={menu} />} extra={extra} style={style} />} data-sentry-element="HeaderComponent" data-sentry-component="InfoPanel" data-sentry-source-file="InfoPanel.jsx" />;
};
export default InfoPanel;